import { render, staticRenderFns } from "./bankContactList.vue?vue&type=template&id=01ed438b&scoped=true"
import script from "./bankContactList.vue?vue&type=script&lang=js"
export * from "./bankContactList.vue?vue&type=script&lang=js"
import style0 from "./bankContactList.vue?vue&type=style&index=0&id=01ed438b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ed438b",
  null
  
)

export default component.exports